import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../../common/';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField';
import FormSelect from '../../../../../antd/form/FormSelect/FormSelect';
import { required } from '../../../../../antd/form/FormValidation';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormTextEditor from '../../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import { documentTypes } from '../../../../../../hooks/useFileDraggerFileValidation.jsx';
import FormCheckBox from '../../../../../antd/form/FormCheckBox/FormCheckBox.jsx';
import { Form } from 'antd';

const HelpForm = ({ roles, onRoleChange, changesMade, routesArray, onURLChange, onSlugChange }) => {
  const { t } = useTranslation();


  const form = Form.useFormInstance();
  const useCustomSlug = Form.useWatch('useCustomSlug', form) || false;


  const rolesOptions = useMemo(
    () => roles.map(role => ({
      value: role.id,
      label: role.name,
    })),
    [roles],
  );

  const handleSlugCheckboxChange = (checked) => {
    const checkedBoolean = checked.target.checked;
    if (checkedBoolean) {
      onSlugChange(null);
    }
  };

  return (
    <>
      <CollapseBlock>
        {!useCustomSlug && (
          <FormSelect
            label={t('URL')}
            name="url"
            options={routesArray}
            placeholder={t('Vyhľadaj URL')}
            rules={[required(t)]}
            onChange={(selectedOption) => onURLChange(selectedOption.value)}
          />
        )}

        <FormCheckBox
          name="useCustomSlug"
          label={t('Použiť špecifickú url so slugom')}
          onChange={handleSlugCheckboxChange}
        />

        <div style={{ marginBottom: '20px' }}>
          {useCustomSlug && (
            <FormTextField
              label={t('URL adresa')}
              name="slug"
              help={t('Skopírujte celú url, alebo vynechajte čísla.')}
              onChange={(value) => onSlugChange && onSlugChange(value)}
              rules={[required(t)]}
            />
          )}
        </div>


        <FormSelect

          label={t('Role pre pomoc')}
          name="choosedRolesIds"
          placeholder={t('Vyhľadať rolu')}
          options={rolesOptions}
          mode="multiple"
          onChange={(selectedRoleIds) => onRoleChange(selectedRoleIds)}
        />

        <FormTextField
          label={t('Nadpis')}
          name="title"
          rules={[required(t)]}
        />

        <FormTextEditor
          label={t('Obsah')}
          name={'content'}
          rules={[required(t)]}
          imgUploadDirectory={'help'}
          fileUploadDirectory={'help'}
          allowedTypes={documentTypes}
        />
      </CollapseBlock>

      <FormButtonsContainer>
        <FormButton disabled={!changesMade} submitKey="help" submitOnClick>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </>
  );
};

HelpForm.propTypes = {
  roles: PropTypes.array.isRequired,
  changesMade: PropTypes.bool,
  onRoleChange: PropTypes.func.isRequired,
  routesArray: PropTypes.array.isRequired,
  onURLChange: PropTypes.func.isRequired,
  onSlugChange: PropTypes.func,
};

export default HelpForm;
